<template>
  <div v-if="loading" class="loader-container"><Loader /></div>
  <div v-else>
    <div v-if="blogDetail" class="detail-page">
      <BlogDetailBanner
        v-if="blogDetail"
        :featuredImage="blogDetail.featuredImage"
        :featuredImageAltText="blogDetail.featuredImageAltText"
        :title="blogDetail.title"
        :tags="blogDetail.tags"
        :publishedDate="blogDetail.publishDate"
        :maxReadTime="blogDetail.maxReadTime"
      />
      <div class="blog-body" v-if="blogDetail.body">
        <div class="v-container body-container">
          <BlogDetailBody
            :body="blogDetail.body"
            :title="blogDetail.title"
            :id="blogDetail.id"
            :slug="blogDetail.slug"
            :metaDescription="blogDetail.metaDescription"
            :tags="blogDetail.tags"
          />
        </div>
      </div>

      <Newsletter />
      <BlogDetailRelatedBlogs
        :relatedBlogs="relatedBlogs"
        :currentBlogTags="blogDetail.tags || []"
        :routePath="'/blogs-and-insights'"
        v-if="relatedBlogs && relatedBlogs.length > 0"
      />
      <GetInTouch background-color="#DEF3FF" />
    </div>
  </div>
</template>

<script setup>
import blogService from '@/services/API/blogService';
import { ref, onMounted } from 'vue';
import { useRoute, onBeforeRouteUpdate } from 'vue-router';
import BlogDetailBanner from '../partials/BlogDetailBanner.vue';
import BlogDetailBody from '../partials/DetailBody.vue';
import Newsletter from '../partials/Newsletter.vue';
import BlogDetailRelatedBlogs from '../partials/DetailRelatedBlogs.vue';
import GetInTouch from './../../service/components/GetInTouch.vue';
import Loader from '@/components/Loader.vue';

window.scrollTo(0, 0);

const route = useRoute();
const blogId = route.params.id;

const blogDetail = ref(null);
const relatedBlogs = ref([]);
const loading = ref(true);
document.getElementById('loaderSection').classList.add('d-none');

const fetchBlog = async (blogId) => {
  try {
    loading.value = true;
    const response = await blogService.showBlogDetail(blogId);
    if (response.status === 200) {
      blogDetail.value = response.data;
      // Check if relatedBlogs is provided by the API
      if (
        blogDetail.value.relatedBlogs &&
        blogDetail.value.relatedBlogs.length > 0
      ) {
        relatedBlogs.value = blogDetail.value.relatedBlogs;
      } else {
        // Fallback: Fetch all blogs and filter by tags
        const allBlogsResponse = await blogService.listAllBlogs('all', '', 0);
        if (allBlogsResponse.status === 200) {
          relatedBlogs.value = allBlogsResponse.data.data
            .filter((blog) => blog.id !== blogId) // Exclude current blog
            .slice(0, 10); // Limit to avoid performance issues
        }
      }
      console.log('Blog Detail:', blogDetail.value);
      console.log('Related Blogs:', relatedBlogs.value);
      console.log('Current Blog Tags:', blogDetail.value?.tags);
    } else {
      throw new Error('Failed to fetch blog details');
    }
  } catch (error) {
    console.error('Error fetching blog:', error);
    relatedBlogs.value = [];
  } finally {
    loading.value = false;
  }
};

onMounted(async () => {
  await fetchBlog(blogId);
});

onBeforeRouteUpdate((to, from, next) => {
  if (to.path !== from.path) {
    window.scrollTo(0, 0);
    loading.value = true;
    const blogId = to.params.id;
    fetchBlog(blogId);
  }
  next();
});
</script>

<style scoped>
.banner-body {
  background-color: var(--light-1);
}
.body-container {
  max-width: 1280px;
}
.blog-body {
  text-align: left;
  background-color: #f7f8fc;
  /* padding: 0rem 1rem; */
}
/* .banner{
  padding: 0 2rem;
}
@media only screen and (max-width: 770px) {
} */
</style>
